/**
 * Global config for all react query hooks
 *
 * https://tanstack.com/query/v4/docs/react/reference/useQuery
 */
export const queryConfig = {
  retry: 7,
  retryDelay: (attemptNumber: number) => {
    // Apply exponential backoff for every retry after 3 retries, max out at 1 minute between retries.
    return Math.min(attemptNumber > 3 ? 2 ** attemptNumber * 1000 : 1000, 60 * 1000);
  },
};
